import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";

export function QueryParamsManagerCosts() {
    const { activePaginationPage, activeEndDate, activeStartDate, activeTagFilter } = useAppSelector(state => state.costsAdminPage);

    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);

    useEffect(() => {
        setQueryParams((params) => {
            if (activePaginationPage) {
                params.set("page", String(activePaginationPage))
            } else {
                params.delete("page")
            }

            if (activeEndDate) {
                params.set("endDate", activeEndDate)
            } else {
                params.delete("endDate")
            }

            if (activeStartDate) {
                params.set("startDate", activeStartDate)
            } else {
                params.delete("startDate")
            }

            if (activeTagFilter) {
                params.set("tagFilter", String(activeTagFilter))
            } else {
                params.delete("tagFilter")
            }

            return params
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, [activePaginationPage, activeEndDate, activeStartDate, activeTagFilter]);

    return <></>
}